import { FC } from 'react'
import { SvgProps } from './svgProps'

const JeansIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width || 32}
    height={height || 32}
    viewBox="0 0 32 32"
  >
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8951"
      stroke={color || '#000'}
      d="M15.248 7.194c0.544 0 0.987-0.582 0.987-1.298v-3.263"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8951"
      stroke={color || '#000'}
      d="M10.394 2.549l-6.143 27.283 6.127 1.784 5.597-22.604 5.597 22.604 6.127-1.784-6.143-27.283h-11.162z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8951"
      stroke={color || '#000'}
      d="M10.394 0.448h11.153v2.101h-11.153v-2.101z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8951"
      stroke={color || '#000'}
      d="M12.346 2.549c0.239 0.391 0.381 0.865 0.381 1.371 0 0.643-0.228 1.233-0.608 1.692l0.004-0.005c-0.517 0.682-1.327 1.118-2.24 1.118-0.146 0-0.29-0.011-0.43-0.033l0.016 0.002"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8951"
      stroke={color || '#000'}
      d="M19.596 2.549c-0.239 0.391-0.381 0.865-0.381 1.371 0 0.643 0.228 1.233 0.608 1.692l-0.004-0.005c0.517 0.682 1.327 1.118 2.24 1.118 0.146 0 0.29-0.011 0.43-0.033l-0.016 0.002"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8951"
      stroke={color || '#000'}
      d="M12.724 0.448v2.101"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8951"
      stroke={color || '#000'}
      d="M19.213 0.448v2.101"
    ></path>
  </svg>
)

export default JeansIcon
